import React, {useReducer, useEffect, useRef} from 'react'
import { ReactComponent as Plus } from '../../img/btn_plus.svg';
import { ReactComponent as Minus } from '../../img/btn_minus.svg';
import './togglecontainer.css';

const ZERO = '0px';
/**
 * Manages the state of the toggle container.
 * @param {Object} state - The current state of the toggle container.
 * @param {Object} action - The action to be processed by the reducer.
 * @returns {Object} The new state of the toggle container.
 */
function ToggleReducer( state, action ){
    switch( action.type ){
        case 'INIT': return action.payload;
        case 'TOGGLE':
            const togg = !state.toggled;
            const target_height = togg ? state.targetHeight : ZERO;
            return {
                ...state,
                maxHeight: target_height,
                toggled: togg
            }
        default:
            console.error(`ToggleReducer broke:\n${JSON.stringify(state)}\n${JSON.stringify(action)}`);
            return state;
    }
}
/**
    * Component that provides a toggleable container for its children.
    * It allows users to expand or collapse the content inside the container.
    * @param {Object} props - The properties passed to the ToggleContainer component.
    * @param {ReactNode} props.children - The content to be displayed inside the toggleable container.
    * @param {boolean} [props.toggled=true] - Initial state of the toggle (expanded or collapsed).
 */
const ToggleContainer = ({ children, toggled=true, fill='White' }) => {
    const innerContainer = useRef(null);
    const [ state, dispatchState ] = useReducer( ToggleReducer, {} );

    useEffect(()=>{
        const containerHeight = innerContainer.current.clientHeight;
        const containerHeightString = `${containerHeight}px`;
        dispatchState({ type:'INIT', payload: {
            toggled: toggled,
            targetHeight: containerHeightString,
            maxHeight: toggled ? containerHeightString : ZERO,
            fill: fill,
        } })
    },[innerContainer]);

    function onToggleClick(e){
        dispatchState({ type:'TOGGLE' });
    }    

    return ( <div className={`toggle-container`}>
        <div onClick={onToggleClick} className='toggle-btn'>
            { state.toggled ? <Minus fill={state.fill}/> : <Plus fill={state.fill}/> }
        </div>
        <div ref={innerContainer} className='toggle-inner-container' style={{ maxHeight: state.maxHeight }}>
            {children}
        </div>
    </div> )
}

export default ToggleContainer;